export default __webpack_public_path__ + "static/media/7C3_E-83.33cb9114.png";